<template>
  <el-upload
    class="file-upload"
    list-type="'text"
    :multiple="false"
    :class="hasFileUpload && 'upload-success'"
    :action="qiniuUploadUrl"
    :data="qiniuData"
    :before-upload="handleBeforeUpload"
    :file-list="fileList"
    :on-success="handleUploadSuccess"
    :on-error="handleUploadError"
    :on-remove="handleFileRemove"
  >
    <el-button v-if="showUpload" size="small" type="primary">{{ $t('microSite.component.upload.clickToUpload') }}</el-button>
    <div v-if="showUpload" class="el-upload__tip" slot="tip">
      <div>{{ $t('microSite.component.upload.fileTips', { maxSize }) }}</div>
      <div v-if="otherTips">{{ otherTips }}</div>
    </div>
  </el-upload>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  model: {
    prop: 'defaultFile',
    event: 'change'
  },
  props: {
    defaultFile: {
      type: [Object, Array],
      required: true
    },
    otherTips: {
      type: [String],
      required: false
    }
  },
  data () {
    return {
      acceptFileSuffix: ['pdf', 'doc', 'docx', 'html', 'png', 'jpeg', 'jpg', 'bmp', 'msword', 'document'],
      tips: null,
      qiniuUploadUrl: window.location.protocol + '//upload.qiniup.com',
      qiniuData: {
        key: null,
        token: null
      },
      file: {
        fileName: '',
        fileUrl: '',
        fileKey: ''
      },
      hasFileUpload: false,
      isMultiple: false,
      limit: 1,
      fileList: [],
      maxSize: 5,
      uploadPrefix: 'microsite/form/config/'
    }
  },
  computed: {
    showUpload () {
      return true
    }
  },
  async created () {
    this.isMultiple = this.defaultFile instanceof Array
    if (this.isMultiple) {
      this.limit = null
    }
    this.file = this.defaultFile
    this.getFileList(this.defaultFile)
    const resp = await this.getQiniuUploadToken({ is_public: true })
    this.qiniuData.token = resp.token
  },
  methods: {
    ...mapActions('common', ['getQiniuUploadToken']),
    ...mapGetters('account', ['getCurrentAccount']),
    handleBeforeUpload (file) {
      if (!this.isAcceptFile(file.type)) {
        this.$message.error(this.$t('microSite.component.upload.fileTypeError'))
        return false
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message.error(this.$t('microSite.component.upload.fileSizeError', { maxSize: this.maxSize }))
        return false
      }
      this.qiniuData.key = this.fileKeyGenerator(file)
      return true
    },
    handleUploadSuccess (resp, file, fileList) {
      this.hasFileUpload = true
      const url = `${process.env.VUE_APP_QINIU_DOMAIN}${this.qiniuData.key}`
      if (this.isMultiple) {
        if (!this.file) {
          this.file = []
        }
        this.file.push({
          fileName: file.name,
          fileUrl: url,
          fileKey: this.qiniuData.key
        })
      } else {
        this.file = {
          fileName: file.name,
          fileUrl: url,
          fileKey: this.qiniuData.key
        }
      }
    },
    handleUploadError (resp, file, fileList) {
      this.hasFileUpload = false
      if (!this.isMultiple) {
        this.file = {
          fileName: '',
          fileUrl: '',
          fileKey: ''
        }
      }
      this.$message({
        message: this.$t('microSite.component.upload.uploadFailed'),
        duration: 2000,
        type: 'warning'
      })
    },
    handleFileRemove (file, fileList) {
      this.hasFileUpload = false
      if (this.isMultiple) {
        if (this.file) {
          const fileIndex = this.file.indexOf(file)
          if (fileIndex > -1) {
            this.file.splice(fileIndex, 1)
          }
        }
      } else {
        this.file = {
          fileName: '',
          fileUrl: '',
          fileKey: ''
        }
      }
    },
    fileKeyGenerator (file) {
      return this.uploadPrefix + this.getCurrentAccount().id + '/' + new Date().valueOf()
    },
    getFileList (file) {
      if (!file) {
        return
      }
      const tempFileList = []
      if (file instanceof Array) {
        for (const item of file) {
          tempFileList.push({ name: item.fileName, url: item.fileUrl })
        }
      } else {
        if (file.fileName) {
          tempFileList.push({ name: file.fileName, url: file.fileUrl })
        }
      }
      this.fileList = tempFileList
      this.hasFileUpload = this.fileList.length > 0
    },
    isAcceptFile (fileType) {
      return _.find(this.acceptFileSuffix, (item) => fileType.endsWith(item))
    }
  },
  watch: {
    file (newVal) {
      if (newVal === this.defaultFile) {
        return
      }
      this.$emit('change', newVal)
      this.getFileList(newVal)
    }
  }
}
</script>

<style lang="scss">
</style>
